<template>
    <div @click="changeSort($attrs.code)" class="font-medium text-gray-900 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer" :class="{'!font-bold text-primary': isActive($attrs.code)}" role="menuitem" tabindex="-1" id="menu-item-0">
        <slot />
    </div>
</template>
  
<script>
export default {
    name: "AppDropdownItem",
    data() {
        return {
            search: new URLSearchParams(window.location.search),
        }
    },
    methods: {
        isActive(code) {
            if (this.search.get('sort') && this.search.get('sort') == code) {
                return true;
            } else {
                return false;
            }
        },
        changeSort(code) {
            var urlString = window.location.href;
            var url = new URL(urlString);
            url.searchParams.delete('sort')
            url.searchParams.append('sort', code);
            window.location.href = url;
        }
    }
};
</script>
  